(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company-customer', {
                parent: 'entity',
                url: '/company-customer?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyCustomer.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-customer/company-customers.html',
                        controller: 'CompanyCustomerController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customerStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('company-customer-detail', {
                parent: 'entity',
                url: '/company-customer/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyCustomer.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-customer/company-customer-detail.html',
                        controller: 'CompanyCustomerDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customerStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CompanyCustomer', function ($stateParams, CompanyCustomer) {
                        return CompanyCustomer.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('company-customer.new', {
                parent: 'supplierPanel',
                url: '/company-customer-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-customer/company-customers.html',
                        controller: 'CompanyCustomerController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            // title: null,
                            // level: null,

                            id: null
                        };
                    }
                }
            })
            .state('company-customer.edit', {
                parent: 'supplierPanel',
                url: '/company-customer-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-customer/company-customers.html',
                        controller: 'CompanyCustomerController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('personInfo');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomer', '$stateParams', function (CompanyCustomer, $stateParams) {

                        return CompanyCustomer.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })

            .state('company-customer.edit2', {
                parent: 'supplierPanel',
                url: '/company-customer-list-2/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {

                    var paramId = $stateParams.id;
                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-pop-up.html',
                        controller: 'CompanyCustomerController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {

                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                // $translatePartialLoader.addPart('company');
                                $translatePartialLoader.addPart('personInfo');
                                // $translatePartialLoader.addPart('serviceItem');
                                // $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                            entity: ['CompanyCustomer', function (CompanyCustomer) {

                                return CompanyCustomer.get({id: paramId}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company-customer.new-pop-up', {
                parent: 'supplierPanel',
                url: '/company-customer-list-2/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {

                    var paramId = $stateParams.id;
                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-pop-up.html',
                        controller: 'CompanyCustomerController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {

                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                // $translatePartialLoader.addPart('company');
                                $translatePartialLoader.addPart('personInfo');
                                // $translatePartialLoader.addPart('serviceItem');
                                // $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                            entity: ['CompanyCustomer', function (CompanyCustomer) {

                                return CompanyCustomer.get({id: paramId}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('company-customer.delete', {
                parent: 'supplierPanel',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-delete-dialog.html',
                        controller: 'CompanyCustomerDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyCustomer', function (CompanyCustomer) {
                                return CompanyCustomer.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-customer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})
();
